import { UserScreenId } from "./userScreenId";

export const Languages: {
    id: number;
    value: string;
    labelInEn: string;
    labelInLanguage: string;
}[] = [
    {
        id: 0,
        value: "en",
        labelInEn: "English",
        labelInLanguage: ""
    },
    {
        id: 1,
        value: "hi",
        labelInEn: "Hindi",
        labelInLanguage: "हिंदी"
    },

    {
        id: 2,
        value: "gu",
        labelInEn: "Gujarati",
        labelInLanguage: "ગુજરાતી"
    },
    {
        id: 3,
        value: "te",
        labelInEn: "Telugu",
        labelInLanguage: "తెలుగు"
    },
    {
        id: 4,
        value: "kn",
        labelInEn: "Kannada",
        labelInLanguage: "ಕನ್ನಡ"
    }
];

export const NAV_UI_LANGUAGES = Languages.filter((language) => language.value === "en" || language.value === "hi");

export const DEFAULT_LANG: number = 0;

export const NAV_MENU_STRINGS = [
    {
        menu: "/",
        languages: NAV_UI_LANGUAGES
    },
    {
        menu: "transporters",
        languages: NAV_UI_LANGUAGES
    },
    {
        menu: "frequently-asked-questions",
        languages: NAV_UI_LANGUAGES
    },
    {
        menu: UserScreenId.cargoInsurance.pathname,
        languages: NAV_UI_LANGUAGES
    }
];

export function getNavLanguagesForRoute(pathname: string, asPath: string) {
    const pathWithoutQuery = asPath.split("?")[0];

    return NAV_MENU_STRINGS.find((item) => {
        if (item.menu === "/") {
            return pathname === "/";
        }

        if (item.menu.startsWith("/")) {
            return pathname === item.menu;
        }

        return pathWithoutQuery.includes(item.menu);
    });
}
